import styled from 'styled-components';

import { inputProps } from '~/styles/metrics';

export const Container = styled.div`
  .MuiFormControl-root {
    ${inputProps};
    display: block;
  }
`;
